import React from "react";
import PropTypes from "prop-types";

const SuggestionList = props => {
  const { active, list, selectItem } = props;
  return (
    <div
      className={`nw-searchbar-suggestionscontainer ${(active && "is-active") ||
        ""}`}
    >
      {list.map(
        item =>
          item.list.length > 0 && (
            <ul className="nw-searchbar-suggestionsul">
              <li className="nw-searchbar-suggestionstitle">{item.title}</li>
              {item.list.map(subitem => (
                <li
                  role="presentation"
                  className="nw-searchbar-suggestionsitem"
                  onMouseDown={() => selectItem(subitem, true)}
                >
                  {subitem}
                </li>
              ))}
            </ul>
          ),
      )}
    </div>
  );
};

SuggestionList.propTypes = {
  active: PropTypes.bool.isRequired,
  list: PropTypes.shape([]).isRequired,
  selectItem: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;
const ProjectComponent = {
  getFinalComponent,
  wrapper: SuggestionList,
  component: SuggestionList,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/molecules/SuggestionList/index.js